import Marquee from "react-fast-marquee";

const PHRASES = [
  "Score Empowerment",
  "Financial Wellness",
  "Funding Readiness",
  "Credit Education",
  "Elevated Apex Co.",
];

const EditorialMarquee = () => (
  <section className="border-y border-white/10 bg-ink-surface py-8 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {PHRASES.map((p, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-3xl sm:text-4xl text-neutral-600 mx-8 whitespace-nowrap hover:text-gold transition-colors duration-500">
            {p}
          </span>
          <span className="w-2 h-2 rotate-45 border border-gold/50 mx-4" />
        </span>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
